import { Tag } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import type { SupportedCurrencies } from 'types/currencies'

import classes from '../styles.module.scss'

type Props = {
  activeCurrency: SupportedCurrencies
  cardCostValue?: string
}

export default function CardCost({ activeCurrency, cardCostValue }: Props) {
  return (
    <div className={classes.infoRowItem}>
      <Tag className={cx(classes.icon, classes[`icon-${activeCurrency}`])} />
      <span>
        <span className={classes.currency}>{activeCurrency}</span>
        {cardCostValue}
      </span>
    </div>
  )
}
